import React, { useCallback } from 'react'
import { Input } from 'rsuite'
import FilterField, { FilterFieldSize } from './FilterField'

export interface FilterMultilineInputProps {
  value: string
  onChange: (value: string) => void
  onBlur?: () => void
  placeholder?: string
  label?: string
  rows?: number
  size?: FilterFieldSize
  /** Парсит строку в массив при onBlur (разделители: пробел, запятая, перенос строки) */
  parseToArray?: (raw: string) => string[]
  onParsedChange?: (parsed: string[]) => void
}

/** Разделяет строку на массив по разделителям */
export const parseMultilineToArray = (raw: string, filterPattern?: RegExp): string[] => {
  const pattern = filterPattern ?? /\S+/
  return raw
    .replace(/[,;\s]+/g, '\n')
    .split('\n')
    .map(s => s.trim())
    .filter(s => s && pattern.test(s))
}

export default function FilterMultilineInput ({
  value,
  onChange,
  onBlur,
  placeholder = 'По одному на строку',
  label,
  rows = 3,
  size = 'normal'
}: FilterMultilineInputProps) {
  return (
    <FilterField size={size} label={label}>
      <Input
        as="textarea"
        value={value}
        onChange={onChange}
        onBlur={onBlur}
        placeholder={placeholder}
        rows={rows}
      />
    </FilterField>
  )
}
